import { PiTimerBold } from "react-icons/pi";
import React, { useContext, useEffect, useState } from "react";
import editarIcon from "../../../../../../../assets/icons/editar.svg";
import horarioIcon from "../../../../../../../assets/icons/clock.svg";
import checkIcon from "../../../../../../../assets/icons/check.svg";
import { greenIcons } from "../../../../../../../utils/icons";
import { useModal } from "../../../../../../../hooks/ModalContext";
import editarWhiteIcon from "../../../../../../../assets/icons/editar_white.svg";
import { useCheckBoxCadastro } from "../../../../../../../hooks/CheckboxCadastroContext";
import { useDividas } from "../../../../../../../context/DividasContext";
import { useCadastro } from "../../../../../../../context/CadastroContext";
import { AtualizaTelefoneProps } from "../../../../../../../types/telefone-atualiza-interface";
import { useFila } from "../../../../../../../context/FilaContext";
import { DiscadorContext } from "../../../../../../Discador";

interface CheckboxProps {
  id: string, checked: boolean
}


export const TabelaTelefone = () => {
  const { setModal, getInfoTel, getHorarioInfo } = useModal();
  const { devedorCadastro } = useDividas()
  const { isTodosChecked } = useCheckBoxCadastro()
  const { telefones, telefoneCheckBox, setTelefoneCheckBox, ultimoCPF } = useCadastro()
  const { devedorFilaSelected, } = useFila()
  const { isLogged, operadorManualState, onCall, iniciarChamada, getTelefoneChamada } = useContext(DiscadorContext)
  // const [checkboxes, setCheckboxes] = useState([
  //   { id: 1, checked: false },
  //   { id: 2, checked: false },
  //   { id: 3, checked: false },
  //   { id: 4, checked: false },
  //   { id: 5, checked: false },
  //   { id: 6, checked: false },
  //   { id: 7, checked: false },
  //   { id: 8, checked: false },
  //   { id: 9, checked: false },
  // ])

  const handleCheckboxToggle = (checkboxId: string) => {
    let updatedCheckboxes: CheckboxProps[]
    if (telefoneCheckBox.find(item => item.id === checkboxId)) {
      updatedCheckboxes = telefoneCheckBox.filter(item => item.id !== checkboxId)
    } else {
      updatedCheckboxes = [...telefoneCheckBox, { id: checkboxId, checked: true }]
    }

    setTelefoneCheckBox(updatedCheckboxes);
  };

  useEffect(() => {
    if (isTodosChecked) {
      const updatedCheckboxes = telefones.map(telefone => {
        return { id: telefone.telefone, checked: true }
      })

      setTelefoneCheckBox(updatedCheckboxes);
    } else {

      if (devedorFilaSelected.cpf_cnpj !== ultimoCPF) {
        setTelefoneCheckBox([]);
      }

    }

  }, [isTodosChecked])

  function formatarTelefone(telefone?: string) {
    telefone = telefone?.replace(/\D/g, '');
    telefone = telefone?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }

  function editTelefone(telefone: AtualizaTelefoneProps) {
    setModal("Editar Telefone", "Telefone")
    getInfoTel(telefone)
  }

  function editHorarios(telefone: AtualizaTelefoneProps) {
    getHorarioInfo(telefone)
    setModal("Editar Horário", "Horário")
  }

  function chamadaButton(telefone: string) {
    getTelefoneChamada(telefone)
    iniciarChamada(
      '',
      telefone.substring(0, 2),
      telefone.substring(2),
      ''
    )
  }

  return (
    <div className="my-2">
      <div className="flex flex-col">
        <div className="overflow-x-hidden ">
          <div className="inline-block  w-full p-1 align-middle">
            <div className="max-h-[150px] overflow-hidden overflow-y-auto rounded-lg  border">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="sticky top-0 bg-primary">
                  <tr>
                    <th scope="col" className="th-cadastro">
                      Situação
                    </th>
                    <th scope="col" className="th-cadastro">
                      Telefone
                    </th>
                    <th scope="col" className="th-cadastro">
                      Ramal
                    </th>
                    <th scope="col" className="th-cadastro ">
                      Tipo
                    </th>
                    <th scope="col" className="th-cadastro">
                      Origem
                    </th>
                    <th scope="col" className="th-cadastro">
                      Acionamento
                    </th>
                    <th scope="col" className="th-cadastro">
                      M.H.
                    </th>
                    <th scope="col" className="th-cadastro">
                      <div className="flex items-center justify-center ">
                        <img src={editarWhiteIcon} alt="" className="h-5 w-5" />
                      </div>
                    </th>
                    <th >
                      <img src={checkIcon} alt="" className="h-5 w-5" />
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">

                  {
                    devedorCadastro?.telefones && telefones?.length > 0 ? telefones.map(telefone => (
                      <tr key={telefone.id_telefone} className={`${devedorFilaSelected.contact === telefone.telefone && 'bg-blue-100'} `}>
                        <td className="td-cadastro">{telefone.situacaotelefone}</td>
                        <td className="td-cadastro">{formatarTelefone(telefone?.telefone)}</td>
                        <td className="td-cadastro"> - </td>
                        <td className="td-cadastro">{telefone.tipo_telefone}</td>
                        <td className="td-cadastro">{telefone.origemtelefone}</td>
                        <td className="td-cadastro">
                          <div className="flex items-center justify-start gap-1" >
                            <button className="hover:opacity-50 disabled:cursor-default disabled:hover:opacity-100" disabled={!isLogged || !operadorManualState || onCall} onClick={() => chamadaButton(telefone.telefone)}>
                              <img
                                src={greenIcons["ligacao"].icons}
                                alt=""
                                className="h-4 w-4"
                              />
                            </button>

                            {telefone.whats !== 'false' && (
                              <img
                                src={greenIcons["whatsapp"].icons}
                                alt=""
                                className="h-4 w-4"
                              />
                            )}
                            {
                              telefone.tipo_telefone.includes('Movel') && (
                                <img
                                  src={greenIcons["sms"].icons}
                                  alt=""
                                  className="h-4 w-4"
                                />
                              )
                            }

                          </div>
                        </td>
                        <td className="td-cadastro">
                          <button
                            className="flex w-full items-center justify-center border-0 bg-transparent outline-none"
                            onClick={() => editHorarios(telefone)}
                          >
                            {/* <img src={horarioIcon} alt="" className="h-6 w-6" /> */}
                            <PiTimerBold size={20} className="fill-primary" />
                          </button>
                        </td>
                        <td className="td-cadastro">
                          <button
                            className="flex w-full items-center justify-center border-0 bg-transparent outline-none"
                            onClick={() => editTelefone(telefone)}
                          >
                            <img src={editarIcon} alt="" className="h-5 w-5" />
                          </button>
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            className="h-3 w-3 rounded-sm accent-primary"
                            checked={telefoneCheckBox && telefoneCheckBox.length > 0 && telefoneCheckBox.find(item => item.id === telefone.telefone) ? true : false}
                            onChange={() => handleCheckboxToggle(telefone.telefone)}
                          />
                        </td>
                      </tr>
                    )) : <tr>

                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro ">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td >

                      </td>
                    </tr>
                  }





                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
